import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Dialog, Typography, DialogContent } from '@mui/material';

type SaveSuccessModalProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  primaryCtaLabel?: string;
  onPrimaryCta?: () => void;
  secondaryCtaLabel?: string;
  onSecondaryCta?: () => void;
};

export default function SaveSuccessModal({
  open,
  onClose,
  title = 'Preferences Updated Successfully',
  description = 'You have successfully updated your preferences. These will be applied to all future Social Value contracts you set up.',
  primaryCtaLabel = 'Return to Home',
  onPrimaryCta = () => {},
  secondaryCtaLabel = 'Continue Editing',
  onSecondaryCta = () => {},
}: SaveSuccessModalProps) {
  const handlePrimary = () => {
    if (onPrimaryCta) {
      onPrimaryCta();
    }
  };

  const handleSecondary = () => {
    if (onSecondaryCta) {
      onSecondaryCta();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            px: 3,
            py: 4,
            borderRadius: 2.5,
            maxWidth: 390,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 3,
          },
        },
      }}
      hideBackdrop={false}
    >
      <CheckCircleIcon color="primary" sx={{ width: '100px', height: '100px', mb: 1 }} />
      <Typography variant="h3">{title}</Typography>
      <DialogContent sx={{ textAlign: 'center', p: 0 }}>
        <Typography variant="body1">{description}</Typography>
      </DialogContent>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={1.5}
        width="100%"
      >
        <Button variant="contained" size="medium" color="primary" onClick={handlePrimary} fullWidth>
          {primaryCtaLabel}
        </Button>
        <Button
          variant="contained"
          size="medium"
          color="secondary"
          onClick={handleSecondary}
          fullWidth
        >
          {secondaryCtaLabel}
        </Button>
      </Box>
    </Dialog>
  );
}
